import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { StripAnalyzeRequest, StripAnalyzeResponse } from './types';

function useDebounced<T>(value: T, ms = 200): T {
  const [d, setD] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setD(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return d;
}

export function useStripAnalysis(request: StripAnalyzeRequest) {
  const debounced = useDebounced(request, 200);
  return useQuery<StripAnalyzeResponse>({
    queryKey: ['zapatas', 'strip', 'analyze', debounced],
    queryFn: async () => {
      const { data } = await api.post<StripAnalyzeResponse>(
        '/api/zapatas/strip/analyze',
        debounced,
      );
      return data;
    },
    placeholderData: (prev) => prev,
    retry: 0,
  });
}
